import { Component, ElementRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Terminal } from '@xterm/xterm';
import { Subscription } from 'rxjs';
import { DialogService, SharedGenericSingletonService, SharedTeltonikaSingletonService } from '@huge-monorepo/shared/services';
import { ICustomerGenericService, ICustomerTeltonikaService, IHIPGenericService, IHIPTeltonikaService } from '@huge-monorepo/shared/interfaces';
import { ActivatedRoute, Router } from '@angular/router';
import { FitAddon } from '@xterm/addon-fit';
import { AttachAddon } from '@xterm/addon-attach';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import { TeltonikaSshLogInModalComponent } from '../../modals/teltonika-ssh-log-in-modal/teltonika-ssh-log-in-modal.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'huge-monorepo-teltonika-device-reverse-ssh',
  standalone: true,
  imports: [CommonModule, MaterialModule],
  templateUrl: './teltonika-device-reverse-ssh.component.html',
  styleUrl: './teltonika-device-reverse-ssh.component.scss',
  encapsulation: ViewEncapsulation.None,

})
export class TeltonikaDeviceReverseSshComponent {
  id: number;
  ip: string;
  public term: Terminal;
  socket: WebSocket;
  waitingRoomSocket: WebSocket;
  @ViewChild('myTerminal') terminalDiv: ElementRef;
  teltonikaService: IHIPTeltonikaService = this.sharedTeltonikaService.getService();
  dialogSub: Subscription;
  resizeSub: Subscription;
  sessionId: string;
  method: string | null;

  constructor(
    private route: ActivatedRoute,
    private sharedTeltonikaService: SharedTeltonikaSingletonService<ICustomerTeltonikaService | IHIPTeltonikaService>,
    private dialog: MatDialog,
    private dialogService: DialogService,
    private sharedGenericService: SharedGenericSingletonService<ICustomerGenericService | IHIPGenericService>,
    private router: Router,
  ) { }

  ngAfterViewInit(): void {

    this.term = new Terminal({
      cursorBlink: true,
      theme: {
        background: '#212121',
        foreground: '#c9c9c9',
      }
    });
    const fitAddon = new FitAddon();

    this.term.loadAddon(fitAddon);
    setTimeout(() => {
      this.term.open(this.terminalDiv.nativeElement);

      fitAddon.fit();
    });
    this.route.paramMap.subscribe(
      (paraMap: any) => {
        if (paraMap.params.id) {
          let id = paraMap.params.id;
          this.id = id;
          this.method = this.route.snapshot.queryParamMap.get('method');
          this.waitForDeviceConnection();
        }
      }
    );
  }

  ngOnDestroy(): void {
    if (this.socket) this.socket.close(1000);
    if (this.resizeSub) this.resizeSub.unsubscribe();
    if (this.dialogSub) this.dialogSub.unsubscribe();
    if (this.term) this.term.dispose();
  }



  waitForDeviceConnection() {
    this.term.writeln("Waiting for device to check for port...");
    this.teltonikaService.readyTeltonikaForReverseSSH(this.id, this.method == 'HTTP' ? 'HTTP' : 'SSH').subscribe({
      next: (data) => {
        if (data != null && data.SessionId != null) {
          this.sessionId = data.SessionId;
          setTimeout(() => {
            this.waitingRoomSocket = this.teltonikaService.waitForTeltonikaReverseSSHConnection(this.id, this.sessionId);

            this.waitingRoomSocket.onmessage = (e: MessageEvent) => {
              this.term.writeln(e.data);
            };

            this.waitingRoomSocket.onerror = (error) => {
              this.waitingRoomSocket.close(1000);
            };

            this.waitingRoomSocket.onclose = (data) => {
              if (data != null && data.reason != null && data.reason.startsWith("ERR:")) {
                this.term.writeln("Error in Setup: " + data.reason);
                return;
              } else {
                if (this.method == "HTTP" && data.reason != null) {
                  // API code for the response: "Host: %s, Port: %d"
                  // Extract the host and port from the response with Regex
                  const response = data.reason;
                  const regex = /Host:\s*(\d{1,3}(?:\.\d{1,3}){3}),\s*Port:\s*(\d{1,5})/;
                  const match = response.match(regex);
                  if (match && match.length === 3) {
                    const host = match[1];
                    const port = match[2];

                    // Navigate in tab to "https://<host>:<port>"
                    const url = `https://${host}:${port}`;
                    this.term.writeln(`Opening SSH tunnel at: ${url}`);
                    window.location.href = url;
                  } else {
                    this.term.writeln("Error: Unable to parse the response from the server.");
                  }
                  return;
                }

                this.term.clear();
                this.openSSH();
              }
            };

          });
        } else {
          this.sharedGenericService.service.createToast('Error', 'Device is not connected to the server. Please check the device connection.', 'error');
        }
      },
      error: (error) => {
        this.term.clear();
        this.term.writeln("Error: Device did not connect to the SSH server.");
        this.sharedGenericService.service.createToast('Error', 'Error while waiting for device to connect to SSH server. Please check the device connection.', 'error');
      }
    });
  }

  /**
     * @description Open SSH tunnel
     * @param ip The IP address to open the tunnel to
     */
  openSSH() {
    const dialogRef = this.dialog.open(TeltonikaSshLogInModalComponent, {
      width: '800px',
      maxHeight: '60vh',
      data: { address: null },
      disableClose: true,
    });

    this.dialogService.RegisterDialog(dialogRef);
    this.dialogSub = dialogRef.afterClosed().subscribe((result) => {
      this.dialogService.DeRegisterDialog(dialogRef);
      this.dialogSub.unsubscribe();
      if (result != null && result.username != null && result.password != null) {
        this.startTerminal(result.username, result.password);
      }
    });

  }

  startTerminal(username: string, password: string) {
    console.log("Starting terminal");

    setTimeout(() => {
      this.socket = this.teltonikaService.openTeltonikaReverseSSHWebsocket(this.id, this.sessionId, this.term.rows, this.term.cols, username, password);

      const attachAddon = new AttachAddon(this.socket);
      this.term.loadAddon(attachAddon);

      this.socket.onmessage = (e: MessageEvent) => {
      };

      this.socket.onerror = (error) => {
        this.socket.close(1000);
      };

      this.socket.onclose = (data) => {
        if (data != null && data.reason != null && data.reason.startsWith("ERR:")) {
          if (data.reason.startsWith("ERR:ssh: handshake failed: ssh: unable to authenticate")) {
            this.sharedGenericService.service.createToast('Error', 'Authentication failed. Please check the username and password and try again.', 'error');
            this.openSSH();
          } else {
            this.term.writeln("Error in Terminal connection: " + data.reason);
          }
        } else {
          this.term.writeln('');
          this.term.writeln(data.reason);
        }

        this.term.writeln('Connection closed');
      };

      this.socket.onopen = () => {

        this.term.writeln(`Attempting to connect with username: ${username}`);

        this.term.onKey((e) => { });
      };

    });
  }
}
